<template>
    <div id="app" class="app" :class="{ 'edit-active': editActive, 'is-admin': isAdmin, 'is-user': !isAdmin }">
        <!-- listen to event "activate-edit" emitted by the child-component Navbar and trigger the event "activatEditMode" -->
        <Navbar :editActive="editActive" :isAdmin="isAdmin" />
        <!-- pass the data-attribute "editActive" to all child components (e.g. used in Index.vue) -->
        <router-view :editActive="editActive" :isAdmin="isAdmin" />

        <!-- <router-link class="mumbl-logo" :to="{ name: 'Index' }"></router-link> -->
        <i class="mumbl-logo"></i>
    </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'
import Navbar from '@/components/layout/Navbar'

export default {
    name: 'App',
    // register components
    components: {
        Navbar
    },
    data() {
        return {
            isAdmin: null,
            editActive: false
        }
    },
    methods: {
        // receives the emitted data (boolean) from the event "activate-edit" and store it in data-attribute "editActive"
        toggleEditMode(boolean) {
            this.editActive = boolean
        },
        // check the active route
        checkRouteForEdit() {
            // Check on route change if given route is true, if it is then hide Nav.
            if (this.$route.path === "/edit-mumblcard" || this.$route.path === "/add-mumblcard") {
                this.editActive = true
            } else  {
                this.editActive = false
            }
        },
        checkRouteForAdmin() {
            // Check on route change if given route is true, if it is then hide Nav.
            if (this.$route.path === "/") {
                let userID = firebase.auth().currentUser.uid

                db.collection('users').doc(userID).get()
                .then(snapshot => {
                    this.isAdmin = snapshot.data().isAdmin
                    $('body').addClass('is-frontend')
                })


            }
            else if (this.$route.path === "/edit-mumblcard" || this.$route.path === "/add-mumblcard") {
                this.isAdmin = true
                $('body').removeClass('is-frontend')
            }
            else {
                this.isAdmin = false
                $('body').removeClass('is-frontend')
            }
        },
    },
    watch: {
        $route() {
            this.checkRouteForEdit()
            this.checkRouteForAdmin()
        }
    },
    created() {
        this.checkRouteForEdit()
        this.checkRouteForAdmin()
    },
}
</script>



<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Lobster');
    @import url('https://fonts.googleapis.com/css?family=Fira+Sans:400,400i');
    @import url('https://fonts.googleapis.com/css?family=Roboto+Slab:400,700');
    @import url('https://fonts.googleapis.com/css?family=Titillium+Web:400,600,700');

    @mixin base-only {
        @media only screen and (max-width: #{$w-base-max}) {
            @content;
        }
    }
    @mixin small {
        @media only screen and (min-width: #{$w-small-min}) {
            @content;
        }
    }
    @mixin small-only {
        @media only screen and (min-width: #{$w-small-min}) and (max-width:#{$w-small-max}) {
            @content;
        }
    }
    @mixin medium {
        @media only screen and (min-width: #{$w-medium-min}) {
            @content;
        }
    }
    @mixin medium-only {
        @media only screen and (min-width: #{$w-medium-min}) and (max-width:#{$w-medium-max}) {
            @content;
        }
    }
    @mixin large {
        @media only screen and (min-width: #{$w-large-min}) {
            @content;
        }
    }
    @mixin large-only {
        @media only screen and (min-width: #{$w-large-min}) and (max-width:#{$w-large-max}) {
            @content;
        }
    }
    @mixin xlarge {
        @media only screen and (min-width: #{$w-xlarge-min}) {
            @content;
        }
    }

    $w-base-max: 		480px;

	$w-small-min: 		481px;
	$w-small-max: 		960px;

	$w-medium-min: 		961px;
	$w-medium-max: 		1360px;

	$w-large-min: 		1361px;
	$w-large-max: 		1920px;

	$w-xlarge-min: 		1921px;


    $c-white             : #ffffff;
    $c-black             : #000000;
    $c1-grey             : #78909c;


    // main
    $c-jellyfish-bg            : #53c7f0;
    $c-jellyfish-gender        : #1d97c1;
    $c-jellyfish-card-top      : #1fa8d7;
    $c-jellyfish-card-bottom   : #87e0ff;
    $c-jellyfish-btns-controls : #1d97c1;
    $c-jellyfish-toasts        : #1d97c1;
    // sidenav
    $c-jellyfish-nav-bg        : #53c7f0;
    $c-jellyfish-fav-card      : #1d97c1;
    $c-jellyfish-fav-gender    : #1d97c1;
    $c-jellyfish-fav-delete    : #1d97c1;
    $c-jellyfish-filter-gender : #1d97c1;

    // main
    $c-squirrel-bg            : #8e98f5;
    $c-squirrel-gender        : #7874f2;
    $c-squirrel-card-top      : #8c88fa;
    $c-squirrel-card-bottom   : #dfe2fe;
    $c-squirrel-btns-controls : #7874f2;
    $c-squirrel-toasts        : #7874f2;
    // sidenav
    $c-squirrel-nav-bg        : #8e98f5;
    $c-squirrel-fav-card      : #7874f2;
    $c-squirrel-fav-gender    : #7874f2;
    $c-squirrel-fav-delete    : #7874f2;
    $c-squirrel-filter-gender : #7874f2;

    // main
    $c-flamingo-bg            : #efa7f3;
    $c-flamingo-gender        : #da72db;
    $c-flamingo-card-top      : #da72db;
    $c-flamingo-card-bottom   : #facbf8;
    $c-flamingo-btns-controls : #da72db;
    $c-flamingo-toasts        : #da72db;
    // sidenav
    $c-flamingo-nav-bg        : #efa7f3;
    $c-flamingo-fav-card      : #da72db;
    $c-flamingo-fav-gender    : #da72db;
    $c-flamingo-fav-delete    : #da72db;
    $c-flamingo-filter-gender : #da72db;


    $c1-backend          : #607d8b;
    $c2-backend          : #455a64;
    $c3-backend          : #78909c;

    $c1-accent           : #c2f9ff;
    $c2-accent           : #c2f9ff;

    $c1-error            : #ff7043;
    $c2-error            : #ff5722;
    $c3-error            : #ffccbc;

    $c1-success          : #00bfa5;
    $c2-success          : #1de9b6;
    $c3-success          : #a7ffeb;

    html {
        height: 100vh;
    }

    body {
        position: relative;
        overflow-x: hidden;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */

        &.is-frontend {
            overflow: hidden;
        }

        .card,
        .card-content {
            border-radius: 10px !important;
        }

        .feedback {

            &.error-light {
                color: $c2-error;
            }
        }
    }

    .app {
        position: relative;
        min-height: 100vh;

        .mumbl-logo {
            display: none;

            @include medium {
                opacity: 0.3;
                display: block;
                position: absolute;
                bottom: 30px;
                right: 50px;
                font-size: 3rem;
                color: #fff;
                width: 120px;
                height: 100px;
                background-repeat: no-repeat;
                background-size: contain;
                background-image: url('./assets/logo-mumbl-babies.svg');
            }
        }

        .nav-content {
            justify-content: flex-end !important;
        }

        &.is-user {

            .nav-extended {
                background: transparent;
                box-shadow: none;
            }

            .nav-links {

                a,
                span {
                    opacity: 0.5;
                    display: inline-block;
                    transition: opacity 0.15s ease-in-out;
                    padding: 1em 0 0 1em !important;
                    font-family: 'Fira Sans', sans-serif !important;
                    color: $c-white;
                }

                a {
                    font-weight: 600;

                    &:hover {
                        opacity: 1;
                        background-color: transparent;
                    }
                }
            }
        }

        &.edit-active {
            background-color: $c1-backend;
            padding-bottom: 200px;

            .nav-extended {
                background-color: $c2-backend;
                box-shadow: none;
            }

            .card {
                background-color: $c2-backend;
            }

            .btn-floating {
                background-color: $c1-accent;

                &.delete {
                    background-color: $c3-backend;

                    &:hover {
                        background-color: $c2-error;
                    }
                }

                .material-icons {
                    color: $c-white !important;
                }

                &:hover {
                    transition: background-color 0.2s ease-in-out;
                    background-color: $c2-accent;
                }
            }
        }
    }


    // COLOR_THEME_ALL
    body {
        .app {
            transition: background 0.02s ease-in-out;

            // MUMBL_CARD
            .mumblcard {
                &__inner {
                    transition: background 0.02s ease-in-out;
                }
            }
        }
    }


    // COLOR_THEME_JELLYFISH
    body.jellyfish {
        .app {
            background: $c-jellyfish-bg;

            &.is-admin {

                .nav-extended {
                    background-color: $c-jellyfish-bg;
                    box-shadow: none;
                }
            }

            &.edit-active {

                .card {
                    background: $c-jellyfish-card-bottom;
                }
                .card-title {
                    color: $c-jellyfish-btns-controls;
                    font-weight: 400;
                }
            }

            // MUMBL_CARD
            .mumblcard {

                &__inner {
                    background: $c-jellyfish-bg;
                    background: -moz-linear-gradient(top, $c-jellyfish-card-top 0%, $c-jellyfish-card-bottom 100%); /* FF3.6-15 */
                    background: -webkit-linear-gradient(top, $c-jellyfish-card-top 0%, $c-jellyfish-card-bottom 100%); /* Chrome10-25,Safari5.1-6 */
                    background: linear-gradient(to bottom, $c-jellyfish-card-top 0%, $c-jellyfish-card-bottom 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

                    .mumblcard__btn {
                        background: $c-jellyfish-gender;
                    }
                }
            }

            // MUMBL_FILTER
            .mumblfilter {
                background: $c-jellyfish-nav-bg;

                &__gender {

                    &.is-active {
                        .mumblfilter__btn {
                            background: $c-jellyfish-filter-gender;
                        }
                        .mumblfilter__gender-text {
                            color: $c-white;
                        }
                    }

                    &:hover {

                        .mumblfilter__btn {
                            background: $c-jellyfish-filter-gender;
                        }
                        .mumblfilter__gender-text {
                            color: $c-white;
                        }
                    }
                }

                &__btn {
                    background: $c-jellyfish-filter-gender;
                    // background: transparent;
                }
            }

            // MUMBL_FAVORITES
            .mumblfav-wrapper {
                background: $c-jellyfish-nav-bg;

                .mumblfav {
                    background: $c-jellyfish-fav-card;

                    &__name {
                        color: $c-white;
                    }

                    &__icon-wrapper {
                        background: $c-jellyfish-fav-gender;

                        .icon {
                            color: $c-white;
                        }
                    }

                    .btn-floating {

                        &.delete {
                            background-color: $c-jellyfish-fav-delete;

                            &:hover {
                                background-color: darken($c-jellyfish-fav-delete, 5%);
                            }
                        }
                    }
                }
            }

            .btn-floating,
            .btn {
                background-color: $c-jellyfish-btns-controls;

                &:hover {
                    background-color: darken($c-jellyfish-btns-controls, 5%);
                }

                &.delete {
                    background-color: $c-jellyfish-fav-delete;

                    &:hover {
                        background-color: darken($c-jellyfish-fav-delete, 5%);
                    }
                }

                .material-icons {
                    color: $c-white !important;
                }
            }

            // AUTH_FORM
            .form-wrapper {
                background: $c-jellyfish-bg;
            }

            form {
                label {
                    font-weight: 700;
                    color: $c-jellyfish-btns-controls;

                    &.active {
                        color: $c-jellyfish-btns-controls;
                    }
                }

                input,
                textarea {
                    border-bottom: 1px solid $c-jellyfish-btns-controls !important;
                    color: $c-jellyfish-btns-controls;

                    &:focus:not([readonly]) {
                        border-bottom: 1px solid $c1-accent !important;
                        -webkit-box-shadow: 0 1px 0 0 $c1-accent !important;
                        box-shadow: 0 1px 0 0 $c1-accent !important;
                    }
                }

                .radio {
                    span {
                        &:before {
                            border-color: $c-jellyfish-btns-controls;
                        }
                        &:after {
                            border-color: $c-jellyfish-btns-controls;
                            background-color: $c-jellyfish-btns-controls;
                        }
                    }
                }
            }

            input {
                border-bottom: 1px solid $c-white !important;
                color: $c-white;

                &:focus:not([readonly]) {
                    border-bottom: 1px solid $c1-accent !important;
                    -webkit-box-shadow: 0 1px 0 0 $c1-accent !important;
                    box-shadow: 0 1px 0 0 $c1-accent !important;
                }
            }
        }

        .toast-error {
            background-color: $c-jellyfish-toasts;
        }
        .toast-warning {
            background-color: $c-jellyfish-toasts;
        }
        .toast-success {
            background-color: $c-jellyfish-toasts;
        }
    }

    // COLOR_THEME_SQUIRREL
    body.squirrel {
        .app {
            background: $c-squirrel-bg;

            &.is-admin {

                .nav-extended {
                    background-color: $c-squirrel-bg;
                    box-shadow: none;
                }
            }

            &.edit-active {

                .card {
                    background: $c-squirrel-card-bottom;
                }
                .card-title {
                    color: $c-squirrel-btns-controls;
                    font-weight: 400;
                }
            }

            // MUMBL_CARD
            .mumblcard {

                &__inner {
                    background: $c-squirrel-bg;
                    background: -moz-linear-gradient(top, $c-squirrel-card-top 0%, $c-squirrel-card-bottom 100%); /* FF3.6-15 */
                    background: -webkit-linear-gradient(top, $c-squirrel-card-top 0%, $c-squirrel-card-bottom 100%); /* Chrome10-25,Safari5.1-6 */
                    background: linear-gradient(to bottom, $c-squirrel-card-top 0%, $c-squirrel-card-bottom 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

                    .mumblcard__btn {
                        background: $c-squirrel-gender;
                    }
                }
            }

            // MUMBL_FILTER
            .mumblfilter {
                background: $c-squirrel-nav-bg;

                &__gender {

                    &.is-active {
                        .mumblfilter__btn {
                            background: $c-squirrel-filter-gender;
                        }
                        .mumblfilter__gender-text {
                            color: $c-white;
                        }
                    }

                    &:hover {

                        .mumblfilter__btn {
                            background: $c-squirrel-filter-gender;
                        }
                        .mumblfilter__gender-text {
                            color: $c-white;
                        }
                    }
                }

                &__btn {
                    background: $c-squirrel-filter-gender;
                    // background: transparent;
                }
            }

            // MUMBL_FAVORITES
            .mumblfav-wrapper {
                background: $c-squirrel-nav-bg;

                .mumblfav {
                    background: $c-squirrel-fav-card;

                    &__name {
                        color: $c-white;
                    }

                    &__icon-wrapper {
                        background: $c-squirrel-fav-gender;

                        .icon {
                            color: $c-white;
                        }
                    }

                    .btn-floating {

                        &.delete {
                            background-color: $c-squirrel-fav-delete;

                            &:hover {
                                background-color: darken($c-squirrel-fav-delete, 5%);
                            }
                        }
                    }
                }
            }

            .btn-floating,
            .btn {
                background-color: $c-squirrel-btns-controls;

                &:hover {
                    background-color: darken($c-squirrel-btns-controls, 5%);
                }

                &.delete {
                    background-color: $c-squirrel-fav-delete;

                    &:hover {
                        background-color: darken($c-squirrel-fav-delete, 5%);
                    }
                }

                .material-icons {
                    color: $c-white !important;
                }
            }

            // AUTH_FORM
            .form-wrapper {
                background: $c-squirrel-bg;
            }

            form {
                label {
                    font-weight: 700;
                    color: $c-squirrel-btns-controls;

                    &.active {
                        color: $c-squirrel-btns-controls;
                    }
                }

                input,
                textarea {
                    border-bottom: 1px solid $c-squirrel-btns-controls !important;
                    color: $c-squirrel-btns-controls;

                    &:focus:not([readonly]) {
                        border-bottom: 1px solid $c1-accent !important;
                        -webkit-box-shadow: 0 1px 0 0 $c1-accent !important;
                        box-shadow: 0 1px 0 0 $c1-accent !important;
                    }
                }

                .radio {
                    span {
                        &:before {
                            border-color: $c-squirrel-btns-controls;
                        }
                        &:after {
                            border-color: $c-squirrel-btns-controls;
                            background-color: $c-squirrel-btns-controls;
                        }
                    }
                }
            }

            input {
                border-bottom: 1px solid $c-white !important;
                color: $c-white;

                &:focus:not([readonly]) {
                    border-bottom: 1px solid $c1-accent !important;
                    -webkit-box-shadow: 0 1px 0 0 $c1-accent !important;
                    box-shadow: 0 1px 0 0 $c1-accent !important;
                }
            }
        }

        .toast-error {
            background-color: $c-squirrel-toasts;
        }
        .toast-warning {
            background-color: $c-squirrel-toasts;
        }
        .toast-success {
            background-color: $c-squirrel-toasts;
        }
    }

    // COLOR_THEME_FLAMINGO
    body.flamingo {
        .app {
            background: $c-flamingo-bg;

            &.is-admin {

                .nav-extended {
                    background-color: $c-flamingo-bg;
                    box-shadow: none;
                }
            }

            &.edit-active {

                .card {
                    background: $c-flamingo-card-bottom;
                }
                .card-title {
                    color: $c-flamingo-btns-controls;
                    font-weight: 400;
                }
            }

            // MUMBL_CARD
            .mumblcard {

                &__inner {
                    background: $c-flamingo-bg;
                    background: -moz-linear-gradient(top, $c-flamingo-card-top 0%, $c-flamingo-card-bottom 100%); /* FF3.6-15 */
                    background: -webkit-linear-gradient(top, $c-flamingo-card-top 0%, $c-flamingo-card-bottom 100%); /* Chrome10-25,Safari5.1-6 */
                    background: linear-gradient(to bottom, $c-flamingo-card-top 0%, $c-flamingo-card-bottom 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

                    .mumblcard__btn {
                        background: $c-flamingo-gender;
                    }
                }
            }

            // MUMBL_FILTER
            .mumblfilter {
                background: $c-flamingo-nav-bg;

                &__gender {

                    &.is-active {
                        .mumblfilter__btn {
                            background: $c-flamingo-filter-gender;
                        }
                        .mumblfilter__gender-text {
                            color: $c-white;
                        }
                    }

                    &:hover {

                        .mumblfilter__btn {
                            background: $c-flamingo-filter-gender;
                        }
                        .mumblfilter__gender-text {
                            color: $c-white;
                        }
                    }
                }

                &__btn {
                    background: $c-flamingo-filter-gender;
                    // background: transparent;
                }
            }

            // MUMBL_FAVORITES
            .mumblfav-wrapper {
                background: $c-flamingo-nav-bg;

                .mumblfav {
                    background: $c-flamingo-fav-card;

                    &__name {
                        color: $c-white;
                    }

                    &__icon-wrapper {
                        background: $c-flamingo-fav-gender;

                        .icon {
                            color: $c-white;
                        }
                    }

                    .btn-floating {

                        &.delete {
                            background-color: $c-flamingo-fav-delete;

                            &:hover {
                                background-color: darken($c-flamingo-fav-delete, 5%);
                            }
                        }
                    }
                }
            }

            .btn-floating,
            .btn {
                background-color: $c-flamingo-btns-controls;

                &:hover {
                    background-color: darken($c-flamingo-btns-controls, 5%);
                }

                &.delete {
                    background-color: $c-flamingo-fav-delete;

                    &:hover {
                        background-color: darken($c-flamingo-fav-delete, 5%);
                    }
                }

                .material-icons {
                    color: $c-white !important;
                }
            }

            // AUTH_FORM
            .form-wrapper {
                background: $c-flamingo-bg;
            }

            form {
                label {
                    font-weight: 700;
                    color: $c-flamingo-btns-controls;

                    &.active {
                        color: $c-flamingo-btns-controls;
                    }
                }

                input,
                textarea {
                    border-bottom: 1px solid $c-flamingo-btns-controls !important;
                    color: $c-flamingo-btns-controls;

                    &:focus:not([readonly]) {
                        border-bottom: 1px solid $c1-accent !important;
                        -webkit-box-shadow: 0 1px 0 0 $c1-accent !important;
                        box-shadow: 0 1px 0 0 $c1-accent !important;
                    }
                }

                .radio {
                    span {
                        &:before {
                            border-color: $c-flamingo-btns-controls;
                        }
                        &:after {
                            border-color: $c-flamingo-btns-controls;
                            background-color: $c-flamingo-btns-controls;
                        }
                    }
                }
            }

            input {
                border-bottom: 1px solid $c-white !important;
                color: $c-white;

                &:focus:not([readonly]) {
                    border-bottom: 1px solid $c1-accent !important;
                    -webkit-box-shadow: 0 1px 0 0 $c1-accent !important;
                    box-shadow: 0 1px 0 0 $c1-accent !important;
                }
            }
        }

        .toast-error {
            background-color: $c-flamingo-toasts;
        }
        .toast-warning {
            background-color: $c-flamingo-toasts;
        }
        .toast-success {
            background-color: $c-flamingo-toasts;
        }
    }



    // TOASTS
    #toast-container {
        position: absolute !important;
        top: auto !important;
        bottom: 20px !important;
        left: 50% !important;
        right: auto !important;
        transform: translateX(-50%);
        z-index: 999999;
        min-width: 0 !important;
        max-width: none !important;
        width: 70%;

        @include small {
            width: auto;
        }
    }
    #toast-container * {
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
    #toast-container > div {
        -webkit-box-shadow: 0px 0px 4px 3px rgba($c-white, 0.1);
        -moz-box-shadow: 0px 0px 4px 3px rgba($c-white, 0.1);
        box-shadow: 0px 0px 4px 3px rgba($c-white, 0.1);
        position: relative;
        overflow: hidden;
        margin: 0 0 6px;
        padding: 10px 20px 10px 60px;
        width: auto !important;
        -moz-border-radius: 3px 3px 3px 3px;
        -webkit-border-radius: 3px 3px 3px 3px;
        border-radius: 50px;
        background-position: 15px center;
        background-repeat: no-repeat;
        font-family: 'Lobster', cursive;
        font-size: 1.2rem;
        color: rgba($c-white, 0.8);
        opacity: 0.8;
        -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
        filter: alpha(opacity=80);

        @include medium {
            padding: 15px 30px 15px 60px;
            font-size: 1.4rem;
        }
    }
    #toast-container > div:hover {
        -moz-box-shadow: 0 0 12px rgba($c-black, 0.3);
        -webkit-box-shadow: 0 0 12px rgba($c-black, 0.3);
        box-shadow: 0 0 12px rgba($c-black, 0.3);
        opacity: 1 !important;
        -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100) !important;
        filter: alpha(opacity=100) !important;
        cursor: pointer;
    }
    #toast-container > .toast-error {
        background-image: url('./assets/icon-heart-thunder.svg') !important;
        background-size: 30px;
        background-position: 15px;

        @include medium {
            background-size: 36px;
            background-position: 15px;
        }
    }
    #toast-container > .toast-success {
        background-image: url('./assets/icon-heart.svg') !important;
        background-size: 30px;
        background-position: 15px;

        @include medium {
            background-size: 36px;
            background-position: 15px;
        }
    }
    #toast-container > .toast-warning {
        background-image: url('./assets/icon-heart-thunder.svg') !important;
        background-size: 30px;
        background-position: 15px;

        @include medium {
            background-size: 36px;
            background-position: 15px;
        }
    }
    .toast {
        // &:nth-last-child(2) {
        //     display: none;
        // }
        &:nth-last-child(3) {
            display: none;
        }
        &:nth-last-child(4) {
            display: none;
        }
        &:nth-last-child(5) {
            display: none;
        }
        &:nth-last-child(6) {
            display: none;
        }
        &:nth-last-child(7) {
            display: none;
        }
        &:nth-last-child(8) {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue